module.exports = __webpack_public_path__ + "static/media/newlogo.31bbd0bc.png";